import { UseAxiosResult } from 'axios-hooks'
import { useCallback, useEffect, useRef } from 'react'
import { apiClient, useAxiosClient } from './configs/axios-setup'

export interface IRequestError {
  status: number
  text: string
}

export const useGetProjects = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      url: '/Projects', //  + (query ? `?${query}` : ''),
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const doFetchRef = useRef(doFetch)

  useEffect(() => {
    doFetchRef.current = doFetch
  }, [doFetch])

  const refetch = useCallback((query?: any) => {
    return doFetchRef.current({
      url: '/Projects' + (query ? `?${query}` : '') // + ',{$sort:{timeCreated:-1},limit:3}'
    })
  }, [])

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetProject = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      url: `/Projects`,
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = id => {
    return doFetch({
      url: `/Projects/${id}`,
      method: 'GET'
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useCreateProject = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      url: '/Projects',
      method: 'POST'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  return [
    { data, loading, error },
    doFetch,
    () => {
      return
    }
  ]
}

export const useUpdateProject = (id: string): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      url: `/Projects/${id}`,
      method: 'PUT'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  return [
    { data, loading, error },
    doFetch,
    () => {
      return
    }
  ]
}

export const useUpdateProjectDescription = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      url: `/Projects/description`,
      method: 'PUT'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ id, description }: any) => {
    return doFetch({
      url: `/Projects/description`,
      data: {
        id: id,
        description: description
      }
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export async function getProjectStatus(id: string) {
  const res = await apiClient.get(`/Projects/${id}`)
  return res
}
